import { CompanyThemeEnum } from "#root/config/enums/company-theme.enum";
import { CompanyEnum } from "#root/config/enums/company.enum";
import { FeatureFlagEnum } from "#root/config/enums/feature-flag.enum";
import { LabelEnum } from "#root/config/enums/label.enum";
import { AppEnvConfig } from "#root/config/interfaces/app-config.interface";

export const APP_CONFIG_RM: AppEnvConfig = {
  appName: CompanyEnum.ResidencialMaya,
  theme: CompanyThemeEnum.ResidencialMaya,
  manualUrl:
    "https://platinosoftware.blob.core.windows.net/maya-residence/Manual_De_Usuario_Crm_Residencial_Maya.pdf",
  minPasswordSize: 8,

  logoLight: "assets/images/companies/residencial-maya/black_letters_logo.png",
  logoDark: "assets/images/companies/residencial-maya/white_letters_logo.png",
  isotype: "assets/images/companies/residencial-maya/app_isotype.png",

  labels: [
    {
      key: LabelEnum.EXAMPLE,
      value: "Example Label",
    },
  ],

  featureFlags: [
    {
      key: FeatureFlagEnum.ERP_INTEGRATION,
      enabled: true,
    },
    {
      key: FeatureFlagEnum.MASS_CUSTOMER_CREATION,
      enabled: false,
    },
    {
      key: FeatureFlagEnum.SHOW_METERS_IN_MULTIPLE_QUOTE,
      enabled: false,
    },
    {
      key: FeatureFlagEnum.PRINT_PAYMENT_PLAN,
      enabled: true,
    },
  ],
};
